export { default, getServerSideProps } from '@/views/AdminDashboard/pages/Home';
